import { iStripeService } from "@/interfaces/services/stripe";
import { iStripeCard, iStripeToken } from "@/interfaces/payments";
import {
  loadStripe,
  Stripe,
  StripeCardElement,
  StripeCardElementChangeEvent,
} from "@stripe/stripe-js";

export class StripeService implements iStripeService {
  protected publishableKey: string;
  protected stripe: Stripe | null = null;

  constructor(publishableKey: string) {
    if (!publishableKey) {
      throw new Error(
        "Attempted to instantiate StripeService with no publishable key",
      );
    }

    this.publishableKey = publishableKey;
    this.stripe = null;
  }

  private async initializeStripe(): Promise<void> {
    if (!this.stripe) {
      this.stripe = await loadStripe(this.publishableKey);
    }
  }

  public async generateCardToken(card: iStripeCard): Promise<iStripeToken> {
    await this.initializeStripe();

    if (!this.stripe) {
      throw new Error("Stripe initialization failed.");
    }

    const elements = this.stripe.elements();
    const cardElement = elements.create("card");

    return new Promise((resolve, reject) => {
      if (!cardElement) {
        return reject(new Error("Failed to create card element."));
      }

      cardElement.mount("#card-element");

      cardElement.on("change", (event: StripeCardElementChangeEvent) => {
        // Handle changes to the card element
        // You may want to update UI based on card validity here
      });

      cardElement.on("blur", () => {
        // Handle blur event
      });

      cardElement.on("focus", () => {
        // Handle focus event
      });

      this.stripe?.createToken(cardElement).then((result) => {
        if (result.error) {
          return reject(result.error);
        }

        resolve(result.token);
      });
    });
  }
}

// Updated usage in components and tests
// Update the places where you use StripeService to pass a StripeCardElement instead of iStripeCard
